import {useI18n} from 'i18n/I18nContext'
import React from 'react'
import {useFormicForm} from 'TemplateEditor/Layout/Blocks'
import {SliderInput} from 'TemplateEditor/Layout/Blocks/ConfigInputs/SliderInput'
import {TextAlignInput} from 'TemplateEditor/Layout/Blocks/ConfigInputs/TextAlignInput'
import {DefaultBlockMobileConfig} from 'TemplateEditor/Layout/Blocks/DefaultBlockMobileConfig'
import {DefaultBlockTopConfig} from 'TemplateEditor/Layout/Blocks/DefaultBlockTopConfig'
import {NormalTextConfigType} from 'TemplateEditor/Layout/Blocks/Text/NormalText'
import {TEMPLATE_EDITOR_ACTIVE_FORM_ID} from 'TemplateEditor/templateEditorFormId'

export function NormalTextMobileConfig() {
  const {t} = useI18n()
  const {handleSubmit, values, setFieldValue} =
    useFormicForm<NormalTextConfigType>()

  return (
    <>
      <form id={TEMPLATE_EDITOR_ACTIVE_FORM_ID} onSubmit={handleSubmit}>
        <DefaultBlockTopConfig values={values} setFieldValue={setFieldValue} />

        <SliderInput
          value={values.mobile.fontSize}
          name={'mobile.fontSize'}
          label={t('templateEditor.textSizeLabel')}
          setFieldValue={setFieldValue}
          max={8}
          min={0.5}
          step={0.1}
        />

        <TextAlignInput
          value={values.mobile.align}
          name={'mobile.align'}
          label={t('templateEditor.textAlignLabel')}
          setFieldValue={setFieldValue}
        />

        <DefaultBlockMobileConfig
          values={values}
          setFieldValue={setFieldValue}
        />
      </form>
    </>
  )
}
